import __request__ from 'routing/request';
/**
 * Get information about currently active stream router engine.
 */
export function getEngineFingerprint(): Promise<unknown> {
    return __request__('GET', '/system/debug/streams/router_engine_info', null, {}, {
        'Accept': ['application/json']
    });
}
